import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=e74f9fe0&scoped=true&"
import script from "./TeamCard.vue?vue&type=script&lang=js&"
export * from "./TeamCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=e74f9fe0&lang=scss&scoped=true&"
import style1 from "./TeamCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f9fe0",
  null
  
)

export default component.exports